import React from "react";
import { Row, Col, InputNumber, Form , Alert} from "antd";
import CurrencySelector from "components/CurrencySelector";
import "./MoneyInputWithCurrencySelector.scss";
import { formatMoney } from 'utils/utils';

export default class MoneyInputWithCurrencySelector extends React.Component {
  state = {
    error: false
  };
  handleCurrencyChange = newSelectedCurrency => {
    if (this.props.onChange) {
      this.props.onChange(
        { amount: this.props.value.amount, currency: newSelectedCurrency },
        "CURRENCY"
      );
    }
  };

  handleAmountChange = newAmount => {
    const { minValue } = this.props;
    // if (!newAmount || parseFloat(newAmount) < minValue) {
    //   this.setState({ error: true });
    //   return;
    // }
    if (newAmount <= 0) {
      this.setState({ error: true });
        return;
    }
    if (this.props.onChange) {
      this.props.onChange(
        { amount: newAmount, currency: this.props.value.currency },
        "AMOUNT"
      );
    }
    this.setState({ error: false });
  };

  render() {
      let amount  = this.props.value.amount;
      if(this.props.targetField && (this.props.value.currency ==='VND' || this.props.value.currency ==='IDR')){
          amount = Math.round(this.props.value.amount)
      }
    const {
      title,
      placeholder,
      value,
      allowedCurrencies,
      minValue
    } = this.props;

    return (
      <Form.Item label={<label style={{ color:  this.props.lableColor ? this.props.lableColor : "black", fontWeight: "bold" }}>{title}</label>}>
        <Row gutter={8}>
          <Col lg={16} md={13} xs={13}>
            <InputNumber
              className="amount-field"
              placeholder={placeholder}
              onChange={this.handleAmountChange}
              onBlur={({ target }) => this.handleAmountChange(target.value)}
              formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              precision={2}
              value={
                formatMoney(amount, 2)
              }
              // min={minValue}
            />
          </Col>
          <Col lg={8} md={11} xs={11}>
            <CurrencySelector
              className="currency-field"
              defaultValue={value.currency}
              currencies={allowedCurrencies}
              onCurrencyChanged={this.handleCurrencyChange}
            />
          </Col>
          {/*{this.state.error && (*/}
          {/*  <div className="ant-form-explain">*/}
          {/*    Source Amount cannot be less than 0*/}
          {/*  </div>*/}
          {/*)}*/}
        </Row>
        {this.props.errorMsgOverLimit && 
        <Row gutter={12} style={{marginTop: "5px"}}>
          <Col span={12} lg={24} md={13} xs={13}>
           <Alert message={this.props.errorMsgOverLimit} type="error" />
          </Col>
        </Row>}
      </Form.Item>
    );
  }
}
